import React, { Component } from "react";
import ReactDOM from 'react-dom';
import { LangContext } from "../LangContext.jsx";
import PendingDocumentsActions from "./PendingDocumentsActions.jsx";
class DossierPendingDocumentsTable extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
    }
    traducirPalabra = (palabra)=>{ 
        const { lang } = this.context;  
        if(palabra == '(es)'){
            return '';
        }
        return lang.get('messages.'+palabra.toLowerCase().replace(/\s+/g, '_').replace(/\s+/g, '_').replace(/[()]/g, '').normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '').replace(/,/g, ''))
    }
    translatePeriod = (texto) => {
        if (texto === null || texto === undefined) {
            return ''; 
            }
            const palabras = texto.split(/\s+/);
            const textoTraducido = palabras.map((palabra) => this.traducirPalabra(palabra)).join(' ');
            return textoTraducido;
    }
    render() {
        const { lang } = this.context; 

        return (
            <>
                <tr>
                    <td colSpan="5">
                        <h5 className="py-5">{this.props.title}</h5>
                    </td>
                </tr>
                {this.props.documents?.map((d, i) => (
                <tr key={i}>
                    <td style={{width: "20px"}}>
                        <div className="symbol symbol-40"> 
                            <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">{ d.document.title[0] }</div>
                        </div>
                    </td>
                    <td colSpan="2"> 
                        { d.document.title }   
                        {this.props.type == "recurrent"   &&
                        <span className="tooltip-mdl">
                            <span><strong> &nbsp; - {d.description_period}  </strong></span> 
                                <span className="tooltip-text-mdl">{this.translatePeriod(d.document.period) } *</span> 
                        </span>  
                        }  
                        &nbsp;
                        { d.document_dossier_state_id == 2 && 
                            <span class="badge badge-incompleto">{lang.get('messages.recurrencia_suspendida')}</span>
                        }
                        <div className="text-dark-65 font-size-sm">
                        ({lang.get('messages.solicitado_el')} { d.requestedDate   } ) 
                        </div>
                    </td>
                    {this.props.type == 'recurrent'  &&
                    <> 
                        <PendingDocumentsActions user_mode={this.props.user_mode} document={d} person_provider_id={this.props.personProviderId} permissions={this.props.permissions} />       
                    </>
                    }
                    {this.props.type != 'recurrent' &&
                    <>
                    <td colSpan="2" className="text-right">
                    {
                    this.props.can_upload_files == 'false' ?
                        <> 
                            <button 
                                className="btn btn-icon btn-light btn-xs"
                                onClick={() => {
                                    let message = '';
                                    if (this.props.user_mode === 'provider') {
                                        message = 'El plan de tu solicitante se encuentra vencido, por lo cual no podrás realizar <b>la carga de documentos</b> solicitados hasta que realice la renovación correspondiente.';
                                    } else {
                                        message = 'Haz llegado al limite de almacenamiento.';
                                    }
                            
                                    Swal.fire({
                                        title: 'No es posible realizar esta acción.',
                                        html: message,
                                        icon: 'error',
                                        buttonsStyling: false,
                                        customClass: {
                                            confirmButton: "btn font-weight-bold btn-primary"
                                        },
                                        confirmButtonText: 'Aceptar'
                                    });
                                }}
                            >
                                <i className="flaticon2-right-arrow text-primary" style={{"fontSize": "0.80rem"}}></i>
                            </button>
                        </>
                            :
                        <a href={"/document_dossier/" + this.props.personProviderId + "/new_file/" + d.id}>
                            <button className="btn btn-icon btn-light btn-xs">
                                <i className="flaticon2-right-arrow text-primary" style={{"fontSize": "0.80rem"}}></i>
                            </button>
                        </a>
                    }
                    </td>
                    </>
                    } 
                </tr>
                ))}
            </>
        );
    }
}

export default DossierPendingDocumentsTable;

if (document.getElementById('DossierPendingDocumentsTable')) {
    ReactDOM.render(<DossierPendingDocumentsTable />, document.getElementById('DossierPendingDocumentsTable'));
}
